module.exports = __webpack_public_path__ + "static/media/coins_icon.8466d607.png";